import memoizeOne from 'memoize-one';
export const itemIsGroup = memoizeOne((item) => item != null && 'children' in item);
export const BaseIconForFolder = 'TS_01.png';
